import Modal from "components/elements/Modal";
import Typography, { ITypo } from "components/elements/Typography";
import Button, { EButtonVariant } from "components/elements/Button";
import I18n from "components/materials/I18n";
import InputElement, { EInputType } from "components/materials/Form/InputElement";
import ProductSubscribedContrepartieUpdateResource from "common/resources/ProductSubscribed/ProductSubscribedContrepartieUpdateResource";
import ProductSubscribedResponseResource from "common/resources/ProductSubscribed/ProductSubscribedResponseResource";
import ProductSubscribedService from "services/ProductSubscribedService";
import { container } from "tsyringe";
import { useCallback, useState } from "react";
import classes from "./classes.module.scss";

const productSubscribedService = container.resolve(ProductSubscribedService);

type IProps = {
	isOpen: boolean;
	onClose: () => void;
	productSubscribedId: string;
	currentContrepartieNom: string | null;
	onSaveSuccess: (updated: ProductSubscribedResponseResource) => void;
};

export default function ContrepartieModal(props: IProps) {
	const [value, setValue] = useState<string>(props.currentContrepartieNom ?? "");

	const handleSave = useCallback(() => {
		const body = ProductSubscribedContrepartieUpdateResource.hydrate<ProductSubscribedContrepartieUpdateResource>({
			contrepartieNom: value.trim() === "" ? null : value.trim(),
		});
		productSubscribedService
			.updateContrepartieAdmin(props.productSubscribedId, body)
			.then(() => productSubscribedService.getByUid(props.productSubscribedId))
			.then((updated) => {
				props.onSaveSuccess(updated);
				props.onClose();
			})
			.catch(console.error);
	}, [props, value]);

	return (
		<Modal isOpen={props.isOpen} onClose={props.onClose} className={classes["root"]}>
			<Typography typo={ITypo.H1}>{I18n.asset.pages.mo_subscription_summary.contrepartie_modal.title}</Typography>
			<InputElement
				type={EInputType.TEXT}
				name="contrepartieNom"
				label={I18n.asset.pages.mo_subscription_summary.contrepartie_modal.label}
				placeholder={I18n.asset.pages.mo_subscription_summary.contrepartie_modal.placeholder}
				defaultValue={props.currentContrepartieNom ?? ""}
				onChange={(e) => setValue(e.target.value)}
			/>
			<div className={classes["button-container"]}>
				<Button onClick={props.onClose} variant={EButtonVariant.OUTLINED}>
					{I18n.asset.pages.mo_subscription_summary.contrepartie_modal.cancel}
				</Button>
				<Button onClick={handleSave}>{I18n.asset.pages.mo_subscription_summary.contrepartie_modal.save}</Button>
			</div>
		</Modal>
	);
}
